import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import TeachersDirectory from './pages/TeachersDirectory';
import TeacherProfile from './pages/TeacherProfile';
import ProjectDetail from './pages/ProjectDetail';
import DonationPage from './pages/DonationPage';
import AboutPage from './pages/AboutPage';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <motion.main
          className="flex-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/teachers" element={<TeachersDirectory />} />
            <Route path="/teacher/:id" element={<TeacherProfile />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="/donate/:projectId" element={<DonationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/contact" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center"><div className="text-center"><h1 className="text-3xl font-bold text-gray-900 mb-4">Contact Us</h1><p className="text-gray-600">Contact page coming soon...</p></div></div>} />
          </Routes>
        </motion.main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;